module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "m-l-50 m-t-30 w-500"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "表单标识",
      "prop": "name"
    }
  }, [_c('span', [_vm._v("form_")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.name),
      expression: "form.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-150",
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        _vm.form.name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "表单名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.title),
      expression: "form.title",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        _vm.form.title = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "表描述"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.des),
      expression: "form.des",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.des)
    },
    on: {
      "input": function($event) {
        _vm.form.des = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "普通索引"
    }
  }, [_vm._l((_vm.form.config.index), function(item, index) {
    return _c('div', {
      staticClass: "m-b-10"
    }, [_c('el-select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.field_id),
        expression: "item.field_id"
      }],
      staticClass: "w-230 m-r-10",
      attrs: {
        "multiple": ""
      },
      domProps: {
        "value": (item.field_id)
      },
      on: {
        "input": function($event) {
          item.field_id = $event
        }
      }
    }, _vm._l((_vm.fields), function(option) {
      return _c('el-option', {
        attrs: {
          "label": option.name + '(' + option.title + ')',
          "value": option.field_id
        }
      })
    })), _vm._v(" "), _c('el-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "w-150",
      attrs: {
        "placeholder": "索引名称"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "input": function($event) {
          item.name = $event
        }
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.deleteIndex(index)
        }
      }
    }, [_vm._v("删除")])])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addIndex
    }
  }, [_vm._v("添加普通索引")])], true), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "唯一索引"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needUnique),
      expression: "needUnique"
    }],
    staticClass: "m-b-10"
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.config.unique.field_id),
      expression: "form.config.unique.field_id"
    }],
    staticClass: "m-r-10",
    attrs: {
      "disabled": _vm.uniqueForbid
    },
    domProps: {
      "value": (_vm.form.config.unique.field_id)
    },
    on: {
      "input": function($event) {
        _vm.form.config.unique.field_id = $event
      }
    }
  }, _vm._l((_vm.fields), function(option) {
    return _c('el-option', {
      attrs: {
        "label": option.name + '(' + option.title + ')',
        "value": option.field_id
      }
    })
  })), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.uniqueForbid),
      expression: "!uniqueForbid"
    }],
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": _vm.deleteUnique
    }
  }, [_vm._v("删除")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.needUnique
    },
    on: {
      "click": _vm.addUnique
    }
  }, [_vm._v("添加唯一索引")])]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.edit()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7fe8dc1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/edit.vue
// module id = 1945
// module chunks = 2